import React, { useState, useEffect } from "react";
import ClaimChecker from "./ClaimChecker";
import ClaimResult from "./ClaimResult";
import { fetchClaimData } from "../api/claimCheck";

export default function ClaimPage() {
  const [resultData, setResultData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Define the stats object outside of JSX
  // const stats = {
  //   aiFactors: {
  //     clarity: 78,
  //     languageStrength: 82,
  //     matchScore: 74
  //   },
  //   voteVerdictBreakdown: {
  //     consistent: 3,
  //     inconsistent: 1,
  //     undecided: 1
  //   },
  //   speechVerdictBreakdown: {
  //     positive: 4,
  //     negative: 2,
  //     ambiguous: 1
  //   },
  //   timeline: [
  //     {
  //       date: "2024-03-01",
  //       bill: "Climate Action Bill",
  //       excerpt: "This legislation sets forth aggressive emissions targets...",
  //       sentiment: "positive"
  //     },
  //     {
  //       date: "2024-03-10",
  //       bill: "Climate Action Bill",
  //       excerpt: "Concerns were raised about economic impact...",
  //       sentiment: "negative"
  //     },
  //     {
  //       date: "2024-03-15",
  //       bill: "Carbon Tax Bill",
  //       excerpt: "The bill outlines tax incentives for green energy...",
  //       sentiment: "positive"
  //     }
  //   ]
  // };

  const handleClaimSubmit = async (claimText) => {
    try {
      setIsLoading(true);
      setError(null);

      const data = await fetchClaimData(claimText);

      if (!data || !data.result) {
        throw new Error("API request failed or returned invalid data");
      }

      setResultData(data.result);
      console.log("Fetched data:", data);
      console.log("Result data:", data.result);
    } catch (err) {
      console.error("Error submitting claim:", err);
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    console.log("Updated resultData:", resultData);
  }, [resultData]);

  // Show loading state
  if (isLoading) {
    return  (<div >
        
        
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p>A.I. is Analyzing your Political Claim against Parliament Records...</p>
    </div>
  </div>);
  }

  // Show error state
  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <>
      {!resultData ? (
        <ClaimChecker onSubmitClaim={handleClaimSubmit} />
      ) : (
        <ClaimResult
          claim={resultData.speech_verdict?.claim_analyzed}
          verdict={resultData.overall_verdict}
          records={resultData.speech_verdict.individual_speech_analyses}
          speech_stats={
            resultData.speech_verdict.overall_speech_analysis_summary
          }
          vote_stats={resultData.vote_verdict.stats}
          counts={resultData.counts}
          speechEvidenceData={
            resultData.speech_verdict.individual_speech_analyses
          }
          vote_records={resultData.vote_verdict.division_list}
        />
      )}
    </>
  );
}
